module.exports = __webpack_public_path__ + "/ece54318791c51b52dfdc689efdb6271.ttf";